<template>
	<article class="top">
		<div class="top__inner">
			<div class="content">
				<h1 class="top__title"><img class="top__title__img" src="@/assets/img/about_header_img02.png" alt="頭痛ーる 気圧予報で体調管理" /></h1>

				<!-- 今日・明日・明後日の天気 -->
				<section class="top__item is-weather-forecast">
					<h2 class="top__item--title">{{ computedWeatherData.place_name }}の天気予報</h2>
					<div class="weather">
						<ul class="weather__tab">
							<v-ons-segment :index.sync="segmentIndex">
								<li @click="onTabChange(0)"><input class="segment__input" type="radio" value="0">今日</li>
								<li @click="onTabChange(1)"><input class="segment__input" type="radio" value="1">明日</li>
								<li @click="onTabChange(2)"><input class="segment__input" type="radio" value="2">明後日</li>
							</v-ons-segment>
						</ul>

						<div class="weather__inner">
							<!-- ローディング -->
							<transition name="fade">
								<webview-redraw-progress v-if="isLoading" />
							</transition>
							<!-- /ローディング -->

							<!-- エラー -->
							<div v-if="isError" class="weather__error">
								<common-error-message>データを正常に<br>取得できませんでした</common-error-message>
							</div>
							<!-- /エラー -->

							<ul class="weather__headline" id="js_headline">
								<li class="weather__headline--item is-time">時間</li>
								<li class="weather__headline--item is-weather">天気</li>
								<li class="weather__headline--item is-temp">気温</li>
								<li class="weather__headline--item is-pressure">気圧<br>(hPa)</li>
								<li class="weather__headline--item is-level">気圧<br>警戒</li>
							</ul>
							<div class="weather__forecast--wrapper" id="js_weather">
								<section
									v-for="(item, indexDay) in computedWeatherData.weather"
									:key="`weather-forecast-day-${indexDay}`"
									:class="[
										'weather__forecast',
										`is-${item.type}`
									]"
								>
									<h2 class="weather__forecast--date" :id="`js_${item.type}_date`">{{ item.date }}</h2>
									<ul
										v-for="(data, indexTime) in item.data"
										:key="`${item.type}-${indexTime}`"
										:id="`js_${item.type}Hour-${indexTime}`"
										class="weather__forecast--list"
									>
										<li class="weather__forecast--item is-time">{{ data.time }}</li>
										<li class="weather__forecast--item is-weather"><i :class="`sprite_weather_point tenki_${data.weather}`" /></li>
										<li class="weather__forecast--item is-temp">{{ data.temp }}<span>&#8451;</span></li>
										<li class="weather__forecast--item is-pressure">
											<span>{{ data.pressure }}</span>
											<i :class="`sprite_weather_point pressure_comparison_${data.diff > 0 ? 'up' : data.diff === 0  ? 'eq' : 'down'}`" />
										</li>
										<li class="weather__forecast--item is-level"><i :class="`sprite_weather_point kiatu_icon_lv${data.pressure_level}`" /></li>
									</ul>
								</section>
							</div>
						</div>
					</div>
				</section>
				<!-- /今日・明日・明後日の天気 -->

				<!-- 服装指数 -->
				<section class="top__item is-clothes-index">
					<clothes-index />
				</section>
				<!-- /服装指数 -->

				<!-- 週間天気 -->
				<section class="top__item is-weekly-weather">
					<div class="non-member">
						<p class="non-member__img"><img src="~@/assets/img/weekly_weather_non_member.png" alt="プレミアムサービスのご案内 天気予報&amp;気圧アラートが10日先まで見られる！ 予定を立てる時にも天気&amp;気圧予報を役立ててほしいニャー"></p>
						<div class="non-member__link">
							<p class="non-member__link--text">
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x2="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
								<span>初回限定・14日間無料でお試し!</span>
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x1="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
							</p>
							<a
								class="non-member__link--button"
								href="https://zutool.jp/about"
								target="_blank"
								rel="noopener noreferrer"
							>
								詳しくはこちらをチェック
							</a>
						</div>
					</div>
				</section>
				<!-- /週間天気 -->

				<!-- 全国マップ -->
				<section class="top__item is-thumbnail-weather-map">
					<h2 class="top__item--title">全国の天気予報</h2>
					<p class="top__item--text">今日・明日・明後日までの全国の天気予報</p>
					<a href="https://zutool.jp/" class="thumbnail-weather-map__wrapper" target="_blank" rel="noopener noreferrer">
						<thumbnail-weather-map @canvasDataUrl='dataUrl = $event' />
					</a>

					<!-- 詳しくみるボタン -->
					<a href="https://zutool.jp/" class="top__button" target="_blank" rel="noopener noreferrer">
						<span class="top__button--text">詳しくみる</span>
					</a>
					<!-- /詳しくみるボタン -->
				</section>
				<!-- /全国マップ -->

				<!-- 頭痛診断 -->
				<section class="top__item is-headache-type-check">
					<h2 class="top__item--title">あなたの頭痛タイプ診断</h2>
					<headache-type-check />
				</section>
				<!-- /頭痛診断 -->

				<!-- フッター -->
				<footer class="top__footer">
					<ul class="top__footer--list">
						<li class="top__footer--item"><a href="https://www.bell24.co.jp/ja/company/about_us/index.html" target="_blank" rel="noopener noreferrer">運営会社</a></li>
						<li class="top__footer--item"><a href="https://zutool.jp/rules" target="_blank" rel="noopener noreferrer">利用規約</a></li>
						<li class="top__footer--item"><a href="https://www.bell24.co.jp/ja/csr/privacy/privacypolicy/bs24.html" target="_blank" rel="noopener noreferrer">個人情報保護方針</a></li>
					</ul>
					<ul class="top__footer--list">
						<li class="top__footer--item"><a href="https://zutool.jp/sending_personal_data" target="_blank" rel="noopener noreferrer">外部送信について</a></li>
						<li class="top__footer--item"><a href="https://zutool.jp/contact" target="_blank" rel="noopener noreferrer">お問い合わせ</a></li>
					</ul>
					<p class="top__footer--copyright">Copyright © Bellsystem24, Inc.<br>All Rights Reserved.</p>
				</footer>
				<!-- /フッター -->
			</div>
		</div>
	</article>
</template>

<script>
// ライブラリ
import axios from 'axios'
import moment from 'moment'
import { scroller } from 'vue-scrollto/src/scrollTo'

// Compornents
import ThumbnailWeatherMap from '@/components/Organisms/ThumbnailWeatherMap'
import ClothesIndex from '@/components/Organisms/ClothesIndex'
import HeadacheTypeCheck from '@/components/Molecules/HeadacheTypeCheck'
import WebviewRedrawProgress from '@/components/Molecules/WebviewRedrawProgress'
import CommonErrorMessage from '@/components/Molecules/CommonErrorMessage'

export default {
	name: 'Top',
	components: {
		ThumbnailWeatherMap,
		ClothesIndex,
		HeadacheTypeCheck,
		WebviewRedrawProgress,
		CommonErrorMessage
	},
	data () {
		return {
			forecast: null,
			isLoading: false,
			isError: false,
			weatherData: null,
			segmentIndex: 0,
			scroller: null,
			now: 0,
			$scrollArea: 0,
			posTomorrow: 0,
			posDayAfterTomorrow: 0,
			isAutoScroll: false
		}
	},
	computed: {
		computedWeatherData () {
			// 初期化
			const res = {
				place_name: '東京都渋谷区',
				weather: [
					{ date: '', type: 'today', data: [] },
					{ date: '', type: 'tommorow', data: [] },
					{ date: '', type: 'dayaftertomorrow', data: [] }
				]
			}
			const obj = {
				pressure: '',
				pressure_level: '',
				temp: '',
				time: '',
				weather: '',
				diff: 0
			}

			for (let i = 0; i < 24; i++) {
				res.weather[0].data[i] = { ...obj }
				res.weather[1].data[i] = { ...obj }
				res.weather[2].data[i] = { ...obj }
			}

			if (this.weatherData) {
				// 地点・日付
				res.place_name = this.weatherData.place_name
				res.weather[0].date = moment(this.weatherData.today.date).format('D日')
				res.weather[1].date = moment(this.weatherData.today.date).add(1, 'days').format('D日')
				res.weather[2].date = moment(this.weatherData.today.date).add(2, 'days').format('D日')

				// 天気データ処理
				let pressureDiff = parseFloat(this.weatherData.today[0].pressure)
				for (let i = 0; i < 3; i++) {
					let weatherData = i === 0 ? this.weatherData.today : i === 1 ? this.weatherData.tommorow : this.weatherData.dayaftertomorrow
					for (let j = 0, len = weatherData.length; j < len; j++) {
						const hourData = weatherData[j]
						res.weather[i].data[j].pressure = hourData.pressure
						res.weather[i].data[j].pressure_level = hourData.pressure_level
						res.weather[i].data[j].temp = Math.round(hourData.temp)
						res.weather[i].data[j].time = hourData.time
						res.weather[i].data[j].weather = hourData.weather
						res.weather[i].data[j].diff = parseFloat(hourData.pressure) - pressureDiff
						pressureDiff = parseFloat(hourData.pressure)
					}
				}
			}

			return res
		}
	},
	mounted () {
		// データの取得
		this.getWeatherData()

		// OnsenUIのbodyスタイルを消す
		document.body.setAttribute('style', 'position: static; overflow: scroll;')
	},
	beforeDestroy () {
		if (this.$scrollArea) this.$scrollArea.removeEventListener('scroll', this.onScroll)
	},
	methods: {
		getWeatherData () {
			// NOTE: storeにデータを保存する必要がないため直接リクエストする（今後、必要ならstoreに移動）
			const url = process.env.VUE_APP_PLATFORM === 'dev_au' || process.env.NODE_ENV === 'test' ? `https://stage.zutool.jp/api/getweatherstatus/13113` : `https://zutool.jp/api/getweatherstatus/13113`
			this.isLoading = true
			axios.request({
				method: 'get',
				url: url
			}).then(res => {
				// console.log(res)	// NOTE: debug
				this.weatherData = res.data

				this.$nextTick(() => {
					this.init()
				})
			}).catch(error => {
				console.log('error: ', error)
				this.isError = true
			}).finally(() => {
				this.isLoading = false
			})
		},

		// 初期化
		init () {
			// VueScrollToオブジェクト生成
			this.scroller = scroller()
			this.now = moment().format('H')
			this.scrollHandler(`js_todayHour-${this.now}`, 'js_weather')

			// DOM処理
			const headlineWidth = document.getElementById('js_headline').offsetWidth
			const headlineLeftMargin = document.getElementById('js_headline').getBoundingClientRect().left
			this.$scrollArea = document.getElementById('js_weather')
			this.$scrollArea.addEventListener('scroll', this.onScroll)
			this.posTomorrow = document.getElementById('js_tommorow_date').getBoundingClientRect().left - (headlineWidth + headlineLeftMargin)
			this.posDayAfterTomorrow = document.getElementById('js_dayaftertomorrow_date').getBoundingClientRect().left - (headlineWidth + headlineLeftMargin)
		},

		// タブ変更処理
		onTabChange (e) {
			switch (e) {
				case 0:
					this.scrollHandler(`js_todayHour-${this.now}`, 'js_weather')
					break
				case 1:
					this.scrollHandler('js_tommorow_date', 'js_weather')
					break
				case 2:
					this.scrollHandler(`js_dayaftertomorrow_date`, 'js_weather')
					break
			}
		},

		// 日単位のスクロール処理
		scrollHandler (id, parentId) {
			const duration = 200
			const $elem = document.getElementById(id)
			const _this = this
			const options = {
				container: `#${parentId}`,
				duration: duration,
				easing: 'ease-out',
				offset: 0,
				force: true,
				cancelable: true,
				onStart: () => { this.isAutoScroll = true },
				onDone: () => {
					setTimeout(() => {
						_this.isAutoScroll = false
					}, duration)
				},
				onCancel: false,
				x: true,
				y: false
			}
			this.scroller($elem, options)
		},

		// 日単位のスクロールイベント監視
		onScroll (e) {
			if (!this.isAutoScroll) {
				const left = e.target.scrollLeft
				if (left < this.posTomorrow) {
					this.segmentIndex = 0
				} else if (left >= this.posDayAfterTomorrow) {
					this.segmentIndex = 2
				} else {
					this.segmentIndex = 1
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/variable";

// NOTE: このページ限定の変数（デザインシステム外のため他での利用禁止）
$color-orange: #FFAD00;
$spacing-12: 0.75rem;

.top {
	.content {
		max-width: 640px;
		margin: 0 auto;
		background-color: $background-secondary;
	}
	&__inner { font-family: $family-primary; }

	&__title {
		padding: $spacing-6 $spacing-10;
		background-color: $primary;
		margin: 0;

		&__img {
			width: 64%;
			display: block;
			line-height: $line-height-1;
		}
	}

	// 共通のスタイル
	&__item {
		padding: 0 $spacing-10;

		&--title {
			font-family: $family-primary;
			color: $primary;
			border-bottom: 2px solid $primary;
			margin: 0 $spacing-10;
			font-size: $font-size-16;
		}

		&--text {
			margin: $spacing-4 0 0;
			font-size: $font-size-14;
			text-align: center;
		}
	}

	// 天気予報のスタイル
	.is-weather-forecast {
		margin-top: 0;
		padding: $spacing-10 0 0;
		background-color: $background-primary;
	}

	.weather {
		margin: 0;
		border-bottom: 1px solid $line-primary;

		ul, li { list-style: none; }
		ul { padding: 0; }

		&__tab {
			margin: $spacing-10 auto 0;
			padding: 0;
			border-bottom: 1px solid $line-primary;

			/deep/ .segment {
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-shadow: none;

				li {
					margin: 0;
					padding: 0;
					width: 32.5%;
					font-size: $font-size-14;
				}

				&__button {
					margin: 0;
					padding: 0;
					border: none;
					border-radius: 0;
					border-top-left-radius: 6px;
					border-top-right-radius: 6px;
					height: 37px;
					line-height: 37px;
					background-color: $background-secondary;
					color: $text-primary;
					font-family: $family-primary;
				}

				:checked + .segment__button {
					background-color: $primary;
					color: $text-seconday;
				}
			}
		}

		&__inner {
			position: relative;
			display: flex;
			align-items: stretch;
		}

		$height-small: 28px;
		$height-large: 51px;
		&__headline {
			position: relative;
			width: 11.25%;
			margin: 0;
			border-right: 1px solid $line-primary;
			text-align: center;
			background: $background-secondary;
			z-index: 2;

			&--item {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: $font-size-10;

				&.is-time { height: $height-small; }
				&.is-weather { height: $height-large; }
				&.is-temp {
					height: $height-small;
				}
				&.is-pressure { height: $height-large; }
				&.is-level { height: $height-large; }
				&:nth-child(even) { background-color: $background-primary; }
			}
		}

		&__forecast {
			display: flex;

			&--wrapper {
				width: 88.75%;
				overflow-x: scroll;
				overflow-y: hidden;
				position: relative;
				display: flex;
				flex-wrap: nowrap;
				position: relative;
				z-index: 1;
			}

			&--date,
			&--list {
				margin: 0;
				min-width: 35px;
				text-align: center;
				border-right: 1px solid $_white;
			}

			&--date {
				display: flex;
				justify-content: center;
				align-items: center;
				background: $background-secondary;
				font-size: $font-size-10;
				font-weight: bold;
			}

			&--item {
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: $font-size-10;
				background: $background-secondary;

				&.is-time { height: $height-small; }
				&.is-weather { height: $height-large; }
				&.is-temp { height: $height-small; }
				&.is-pressure {
					height: $height-large;
					flex-direction: column;

					& > span {
						display: inline-block;
						font-size: $font-size-8;
					}
					& > i { margin-top: $spacing-10; }
				}
				&.is-level { height: $height-large; }
				&:nth-child(even) { background-color: $background-primary; }
			}
		}
	}

	// 週間天気のスタイル
	.is-weekly-weather {
		margin-top: $spacing-10;
		padding: 0;

		// 週間天気の非会員用
		.non-member {
			position: relative;

			&__img {
				margin: 0;

				& > img {
					display: block;
					width: 100%;
				}
			}

			&__link {
				font-family: $family-primary;
				position: absolute;
				width: 100%;
				bottom: 6.25%;
				left: 0;
				margin: 0;
				text-align: center;

				&--text {
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 0;
					font-size: $font-size-12;
				}

				&--button {
					display: block;
					width: 73.125%;
					margin: $spacing-2 auto 0;
					padding: $spacing-12 $spacing-18;
					font-size: $font-size-14;
					box-sizing: border-box;
					border-radius: 10px;
					background-color: $color-orange;
					color: $text-seconday;
					text-decoration: none;
					line-height: $line-height-1;
				}
			}
		}
	}

	// 健康天気指数のスタイル
	.is-health-weather {
		margin-top: $spacing-10;
		padding: $spacing-12 $spacing-10 $spacing-16;
		background-color: $background-primary;

		/deep/ .health-weather__wrapper {
			padding: 0;
			margin: 0;
		}

		/deep/ .health-weather__title {
			font-family: $family-primary;
			margin: 0 0 $spacing-10;
			padding: 0;
			font-size: $font-size-16;
			color: $primary;
			border-bottom: 2px solid $primary;

			&::before { content: none; }
		}
	}

	// 全国の気温と服装の目安
	.is-clothes-index {
		padding: 0;
	}

	// 全国マップのスタイル
	.is-thumbnail-weather-map {
		margin-top: $spacing-10;
		padding: $spacing-12 0 $spacing-16;
		background-color: $background-primary;
	}

	.thumbnail-weather-map__wrapper {
		display: block;
		width: 57.5%;
		margin: $spacing-8 auto 0;
		box-sizing: border-box;
	}

	// 頭痛診断のスタイル
	.is-headache-type-check {
		margin-top: $spacing-10;
		padding: $spacing-12 0 $spacing-16;
		background-color: $background-primary;
	}

	// ボタン
	&__button {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 57.5%;
		height: 30px;
		margin: $spacing-8 auto 0;
		font-size: $font-size-12;
		text-decoration: none;
		color: $primary;
		border: 1px solid $primary;
		border-radius: 10px;
		box-sizing: border-box;

		&--text {
			padding-left: $spacing-4;
			line-height: $line-height;
		}

		@media screen and (min-width: 375px) { height: 35px; }
		@media screen and (min-width: 390px) { height: 36px; }
		@media screen and (min-width: 428px) { height: 40px; }
	}

	&__footer {
		padding: $spacing-20 $spacing-10;
		text-align: center;

		&--list {
			padding: 0;
			margin: 0;
			list-style: none;

			&:last-of-type { margin: $spacing-10 0 0; }
		}

		&--item {
			display: inline-block;
			padding: 0 $spacing-10;
			box-sizing: border-box;
			border-right: 1px solid $line-primary;

			&:first-of-type { border-left: 1px solid $line-primary; }

			& > a {
				color: $text-primary;
				text-decoration: none;
			}
		}

		&--copyright {
			margin: $spacing-10 0 0;
		}
	}
}

.sprite_weather_point {	// 時単位
	background-image: url(~@/assets/img/sprite_weather_point.png);
	background-size: (88px / 2.5) (946px / 2.5);
	background-repeat: no-repeat;
	display: block;

	&.kiatu_icon_lv0 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-5px / 2.5);
	}

	&.kiatu_icon_lv1 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-99px / 2.5);
	}

	&.kiatu_icon_lv2 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-193px / 2.5);
	}

	&.kiatu_icon_lv3 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-287px / 2.5);
	}

	&.kiatu_icon_lv4 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-381px / 2.5);
	}

	&.kiatu_icon_lv5 {
		width: (78px / 2.5);
		height: (84px / 2.5);
		background-position: (-5px / 2.5) (-475px / 2.5);
	}

	&.pressure_comparison_down {
		width: (30px / 2.5);
		height: (24px / 2.5);
		background-position: (-5px / 2.5) (-569px / 2.5);
	}

	&.pressure_comparison_eq {
		width: (30px / 2.5);
		height: (24px / 2.5);
		background-position: (-5px / 2.5) (-603px / 2.5);
	}

	&.pressure_comparison_up {
		width: (30px / 2.5);
		height: (24px / 2.5);
		background-position: (-5px / 2.5) (-637px / 2.5);
	}

	&.tenki_100 {
		width: (60px / 2.5);
		height: (60px / 2.5);
		background-position: (-5px / 2.5) (-671px / 2.5);
	}

	&.tenki_200 {
		width: (60px / 2.5);
		height: (60px / 2.5);
		background-position: (-5px / 2.5) (-741px / 2.5);
	}

	&.tenki_300 {
		width: (60px / 2.5);
		height: (60px / 2.5);
		background-position: (-5px / 2.5) (-811px / 2.5);
	}

	&.tenki_400 {
		width: (60px / 2.5);
		height: (60px / 2.5);
		background-position: (-5px / 2.5) (-881px / 2.5);
	}
}
</style>
